var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.79476 7.05601C4.79476 5.80701 5.80676 4.79501 7.05576 4.79401H8.08476C8.68176 4.79401 9.25376 4.55701 9.67776 4.13701L10.3968 3.41701C11.2778 2.53101 12.7098 2.52701 13.5958 3.40801L13.5968 3.40901L13.6058 3.41701L14.3258 4.13701C14.7498 4.55801 15.3218 4.79401 15.9188 4.79401H16.9468C18.1958 4.79401 19.2088 5.80601 19.2088 7.05601V8.08301C19.2088 8.68001 19.4448 9.25301 19.8658 9.67701L20.5858 10.397C21.4718 11.278 21.4768 12.71 20.5958 13.596L20.5948 13.597L20.5858 13.606L19.8658 14.326C19.4448 14.749 19.2088 15.321 19.2088 15.918V16.947C19.2088 18.196 18.1968 19.208 16.9478 19.208H16.9468H15.9168C15.3198 19.208 14.7468 19.445 14.3238 19.866L13.6038 20.585C12.7238 21.471 11.2928 21.476 10.4068 20.597C10.4058 20.596 10.4048 20.595 10.4038 20.594L10.3948 20.585L9.67576 19.866C9.25276 19.445 8.67976 19.209 8.08276 19.208H7.05576C5.80676 19.208 4.79476 18.196 4.79476 16.947V15.916C4.79476 15.319 4.55776 14.747 4.13676 14.324L3.41776 13.604C2.53176 12.724 2.52676 11.293 3.40676 10.407C3.40676 10.406 3.40776 10.405 3.40876 10.404L3.41776 10.395L4.13676 9.67501C4.55776 9.25101 4.79476 8.67901 4.79476 8.08101V7.05601",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43164 14.5718L14.5716 9.43176",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4955 14.5H14.5045",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4955 9.5H9.5045",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/Price.97031d9687a3a303fcd3a7e3ebb43d77.svg";
export { ForwardRef as ReactComponent };